module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/chapimage.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("After Elise fell asleep, Rose crept to the garden."), _c('br'), _vm._v("Ombrine had ordered her to stay out of it—"), _c('br'), _vm._v("especially at night—and promised severe"), _c('br'), _vm._v("punishment if she disobeyed")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("B")]), _vm._v("ut it was in this garden she had last seen her mother, and had heard the joyous news that her father was coming home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("You are loved,”")]), _vm._v(" the roses whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I "), _c('em', [_vm._v("was")]), _vm._v(" loved: she said brokenly. “But now they’re gone:’ She began to cry again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moonlight gleamed around Rose like her mother’s sheltering arms, and after a time, she fell into a deep, heavy sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And in that sleep, a glowing hand cupped a shimmering white mouth pressed against her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A voice whispered, "), _c('em', [_vm._v("‘Alas, daughter of she who made the wish, you still must walk through the shadows until you see the light. Once you learn the lesson, two broken hearts shall mend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose slumbered and didn’t hear the voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But her heart heard it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d139c4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 57
// module chunks = 0